import { useState } from 'react';

/* Shared Klaviyo-wired submit flow: validate -> send -> status message */
export function useKForm() {
  const [msg, setMsg] = useState({ kind: 'idle', text: '' });

  const handleSubmit = ({ validate, send, okText }) => async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const trap = form.querySelector('[name=website]');
    if (trap && trap.value) return; // bot trap
    setMsg({ kind: 'idle', text: '' });
    const err = validate(form);
    if (err) {
      setMsg({ kind: 'err', text: err });
      return;
    }
    const btn = form.querySelector('[type=submit]');
    const label = btn ? btn.textContent : '';
    if (btn) btn.disabled = true;
    try {
      await send(form);
      form.reset();
      setMsg({ kind: 'ok', text: okText });
    } catch (x) {
      setMsg({ kind: 'err', text: "That didn't go through. Please try again in a moment." });
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.textContent = label;
      }
    }
  };

  return { msg, setMsg };
}

export function Field({ label, htmlFor, children }) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={htmlFor} className="text-sm font-bold text-ivory">
        {label}
      </label>
      {children}
    </div>
  );
}

export const inputCls =
  'w-full rounded-2xl border border-plum-line2 bg-plum-deep px-5 py-4 text-base text-ivory placeholder:text-[#9C8A86] transition-[border-color,box-shadow] duration-200 focus:border-gold/70 focus:outline-none focus:ring-2 focus:ring-gold/30';

export function Status({ msg, okCls = 'text-sky', errCls = 'text-[#F2A7A0]' }) {
  if (msg.kind === 'idle' && !msg.text) return <p className="min-h-[1.5em] text-[15px]" aria-live="polite" data-testid="form-status" />;
  return (
    <p className={`min-h-[1.5em] text-[15px] ${msg.kind === 'ok' ? okCls : errCls}`} role="status" aria-live="polite" data-testid="form-status">
      {msg.text}
    </p>
  );
}
